// @todo: effort minimal sur ce mapper, du fait que le Content Model est voué à disparaître au profit de Common Item.
import { Asset } from '@b2ag/contentful'

import { CommonItemDisplayType } from '../../../../common-item/domain/CommonItemDisplayType'
import type { ContentMedia, ContentMediaImage } from '../../../../content-media/domain/ContentMedia'
import { ContentModelId } from '../../../../../types/ContentModelId'
import type { ContentPage } from '../../../../content-page/domain/ContentPage'
import type { FaqBlock } from '../../../../faq-block/domain/FaqBlock'
import type { ListItems } from '../../../domain/ListItems'
import type { ListItemsDTO } from '../../../domain/ListItemsDTO'
import type { PartnerId } from '../../../../../types/PartnerId'
import type { SkinVariant } from '../../../../../types/SkinVariant'

import { assetDtoToUrl } from '../../../../../utils/asset-dto-to-url'
import { isAvailablePartner } from '../../../../../utils/filter-by-partner'
import { isNonNullableEntryDTO } from '../../../../../utils/non-nullable-entry-dto'
import { mapEntryDTOList } from '../../../../../utils/map-entry-dto-list'

const assetsToContentMediaImage = (image?: Asset, imageMobile?: Asset): ContentMediaImage => {
  return {
    id: assetDtoToUrl(image) || '',
    contentType: ContentModelId.CONTENT_MEDIA,
    source: {
      desktop: assetDtoToUrl(image),
      mobile: assetDtoToUrl(imageMobile),
    },
    type: 'image',
  }
}

export const mapListItemsFromApi = (dto: ListItemsDTO, partnerId?: PartnerId): ListItems | undefined => {
  if (!(isNonNullableEntryDTO(dto) && isAvailablePartner(partnerId, dto.fields.partnerFilter))) {
    return undefined
  }

  const { anchorLabel, backgroundColor, backgroundImage, blocs, metrics, mobileBackgroundImage, title } = dto.fields

  const children = mapEntryDTOList<ContentMedia | ContentPage | FaqBlock>(blocs) || []
  const displayType = metrics
    ? CommonItemDisplayType.PORTAL_METRICS_LIST_ITEMS
    : CommonItemDisplayType.PORTAL_REINSURANCE_LIST_ITEMS

  return {
    anchorLabel,
    children,
    contentType: ContentModelId.LIST_ITEMS,
    displayType,
    media: assetsToContentMediaImage(backgroundImage, mobileBackgroundImage),
    skinVariant: backgroundColor?.replace('-color', '') as SkinVariant,
    title,
  }
}
